// 事件类型
export const ERROR_TYPES = {
  JAVASCRIPT: 'JAVASCRIPT_ERROR',
  NATIVE: 'NATIVE_MODULE_ERROR',
  UI_RENDER: 'UI_RENDER_ERROR',
  PROMISE: 'PROMISE_ERROR',
  RESOURCE: 'RESOURCE_LOAD_ERROR',
  FRAMEWORK: 'FRAMEWORK_ERROR',
};

// 常量
export const CONSTANT = {
  TRACE_ID: '_monitor_trace_id',
  NOT_SEND: '_monitor_not_send',
};

// 多久缓存一次数据
export const CACHE_TIME = 3000;

export const reportApi = 'https://beats-info.be.mi.com/mishoplog?format=json';
